function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332 376h-30V256h30c22.091 0 40 17.909 40 40v40c0 22.091-17.909 40-40 40zM432 256v120M432 256h60M472 316h-40M172 376V256M212 256h-40v60h40c16.569 0 30-13.431 30-30v0c0-16.569-13.431-30-30-30zM180 96v80",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 174.179V100c0-11.046-4.478-21.046-11.716-28.284l-40-40C281.045 24.477 271.045 20 260 20H60c-22.091 0-40 17.909-40 40v392c0 22.091 17.909 40 40 40h229.774c22.089 0 40-17.905 40-39.994V452",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 136 40 40 40-40",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/download-pdf.381414d924112f9a5b216de7183eb382.svg";
export { ForwardRef as ReactComponent };